import { useContext, useEffect, useState } from "react";
import { BsFillHeartPulseFill } from "react-icons/bs";
import { FaBed } from "react-icons/fa";
import { MdSignalWifiConnectedNoInternet2 } from "react-icons/md";
import { IoIosWifi } from "react-icons/io";
import { TfiHeartBroken } from "react-icons/tfi";
import "./style.css";
import { Link } from "react-router-dom";
import slugify from "react-slugify";
import { DasboardContext } from "../../context/dashboard-context";
import AlarmModal from "../AlarmModal/AlarmModal";
import LastFiveAlarm from "../LastFiveAlarm/LastFiveAlarm";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import { SlSpeedometer } from "react-icons/sl";
import { FaPlugCircleXmark } from "react-icons/fa6";
import { PiBedFill } from "react-icons/pi";
import { FaRegCalendarCheck } from "react-icons/fa";
import { GiRadarSweep } from "react-icons/gi";
import { FaHeartbeat, FaLungs, FaIdBadge } from "react-icons/fa";
import { BiSolidWatchAlt } from "react-icons/bi";
import { ImHeart } from "react-icons/im";
import { FaLocationDot, FaBatteryThreeQuarters } from "react-icons/fa6";
import { IoManSharp } from "react-icons/io5";
import { MdLocationPin } from "react-icons/md";

import { FcInfo } from "react-icons/fc";

// Hoba token alma fonksiyonu - backend üzerinden istek atar (CSP sorunu için)
const fetchHobaToken = async () => {
	try {
		const response = await fetch("https://app.vivasmartcare.com/api/hoba-token", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		});

		const result = await response.json();
		console.log("Hoba API yanıtı:", result);

		if (result.success && result.access_token) {
			return result.access_token;
		} else {
			const errorMsg = result.message || "Bilinmeyen hata";
			console.error("Hoba token alma hatası:", errorMsg);
			alert("Token alınamadı: " + errorMsg);
			return null;
		}
	} catch (error) {
		console.error("Hoba token isteği başarısız:", error);
		alert("Bağlantı hatası, lütfen tekrar deneyin.");
		return null;
	}
};

const SameSuitCard = ({ bed }) => {
	const [show, setShow] = useState(false);
	const [lastAlarmsShow, setLastAlarmsShow] = useState(false);
	const [minidata, setMinidata] = useState([]);
	const [suBed, setSuBed] = useState();
	const [alarms, setAlarms] = useState([]);
	const [userDetail, setUserDetail] = useState([]);
	const [alarm, setAlarm] = useState();
	const [lastAlarmId, setLastAlarmId] = useState();

	const [heartBreath, setHeartBreath] = useState([]);
	const [position, setPosition] = useState([]);
	const [hbstatics, setHbstatics] = useState([]);

	const [outBedModalShow, setOutBedModalShow] = useState(true);
	const [vivistar, setVivistar] = useState({}); // V46 cihaz verileri
	const [v46AlarmPopup, setV46AlarmPopup] = useState(null); // V46 alarm popup
	const [lastV46AlarmCheck, setLastV46AlarmCheck] = useState(
		new Date().toISOString()
	);
	const [heartRateMessage, setHeartRateMessage] = useState(null); // Kalp atış ölçümü mesajı
	const [heartRateMessageType, setHeartRateMessageType] = useState(null); // success veya danger
	const [locationMessage, setLocationMessage] = useState(null); // Konum isteği mesajı
	const [locationMessageType, setLocationMessageType] = useState(null); // success veya danger
	const [requestingLocation, setRequestingLocation] = useState({}); // Hangi cihazlar için konum isteniyor

	const outBedClose = () => setOutBedModalShow(false);
	const outBedShow = () => setOutBedModalShow(true);
	const closeV46AlarmPopup = () => {
		setV46AlarmPopup(null);
		window.location.reload();
	};

	const {
		states,
		events,
		topic,
		setCheckedItems,
		filter,
		messages,
		battery,
		hobaData,
	} = useContext(DasboardContext);

	const [bedStatesMap, setBedStatesMap] = useState({});
	const [bedEventsMap, setBedEventsMap] = useState({});
	const [hobaEventsMap, setHobaEventsMap] = useState({});
	const [bedMessagesMap, setBedMessagesMap] = useState({});

	const [logs, setLogs] = useState({});

	const handleShow = () => setShow(true);
	const closeModal = () => setShow(false);
	const closeLastAlarmsModal = () => setLastAlarmsShow(false);

	const handleToggleChange = (deviceID, isChecked) => {
		if (isChecked) {
			setCheckedItems((prevItems) => [...prevItems, deviceID]);
		} else {
			setCheckedItems((prevItems) => prevItems.filter((id) => id !== deviceID));
		}
	};

	const symbols = {
		Mutfak: "countertops",
		Banyo: "bathtub",
		"Yatak Odası": "king_bed",
		"Yemek Odası": "table_restaurant",
		"Oturma Odası": "scene",
	};

	function extractIdFromUrl() {
		const parts = topic?.split("/");
		const idPart = parts?.find((part) => part.startsWith("id_"));
		return idPart || null;
	}

	async function getAlarmDetail() {
		try {
			const promises = bed.items.map(async (sbed) => {
				const response = await fetch(
					`https://app.vivasmartcare.com/api/alarm-logs/${sbed.deviceID}`
				);
				return response.json();
			});

			const alarmResponses = await Promise.all(promises);
			setAlarms((prevAlarms) => [...prevAlarms, ...alarmResponses]);
		} catch (error) {
			console.error("Veri getirilirken bir hata oluştu:", error);
		}
	}

	async function getUserDetails() {
		try {
			const promises = bed?.items.map(async (sbed) => {
				const response = await fetch(
					`https://app.vivasmartcare.com/api/user/${sbed.person}`
				);
				return response.json();
			});
			const userDetails = await Promise.all(promises);
			setUserDetail((prevUser) => [...prevUser, ...userDetails]);
		} catch (error) {
			console.error("Veri getirilirken bir hata oluştu:", error);
		}
	}

	function countAlarmsByDeviceId(alarms, deviceID) {
		let count = 0;

		alarms
			.filter((alarmArray) => alarmArray.length > 0)
			.forEach((alarmArray) => {
				const filteredAlarms = alarmArray.filter(
					(alarm) => alarm.deviceId === deviceID
				);
				count += filteredAlarms.length;
			});

		return count;
	}

	function dateFormat(myDate) {
		const options = {
			weekday: "short",
			year: "numeric",
			month: "short",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			second: "numeric",
			hour12: false,
			timeZone: "Europe/Istanbul",
		};
		return new Date(myDate).toLocaleDateString("tr-TR", options);
	}

	// Vivistar (V46) cihaz verilerini çek
	const fetchVivistar = async (deviceId) => {
		try {
			const response = await fetch(
				`https://app.vivasmartcare.com/api/v46-device-summary/${deviceId}`
			);
			if (response.ok) {
				const data = await response.json();
				console.log(`[V46] Cihaz Veri Güncellemesi (${deviceId}):`, data);
				setVivistar((prev) => ({
					...prev,
					[deviceId]: data,
				}));
			}
		} catch (error) {
			console.error("Vivistar veri çekme hatası:", error);
		}
	};

	// Vivistar konum isteği gönder (CR komutu)
	const requestVivistarlocation = async (deviceId) => {
		try {
			setRequestingLocation((prev) => ({ ...prev, [deviceId]: true }));
			const response = await fetch("https://app.vivasmartcare.com/api/v46-request-location", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ deviceId }),
			});

			if (response.ok) {
				const data = await response.json();
				setLocationMessage(data.message || "Konum isteği gönderildi");
				setLocationMessageType("success");
				setTimeout(() => {
					setLocationMessage(null);
					setLocationMessageType(null);
				}, 3000);

				// Verileri yenile ve konum kontrolü yap
				setTimeout(() => fetchVivistar(deviceId), 1000);
				setTimeout(() => fetchVivistar(deviceId), 5000);
				setTimeout(async () => {
					await fetchVivistar(deviceId);
					// 15 saniye sonra hâlâ konum yoksa uyarı göster
					const loc = vivistar[deviceId]?.location;
					if (!loc || !loc.latitude || !loc.longitude) {
						setLocationMessage("Cihazdan konum verisi alınamadı. Cihaz kapalı veya GPS sinyali yok olabilir.");
						setLocationMessageType("warning");
						setTimeout(() => {
							setLocationMessage(null);
							setLocationMessageType(null);
						}, 5000);
					}
				}, 15000);
			} else {
				const errorData = await response.json();
				setLocationMessage(errorData.error || "Konum isteği gönderilemedi");
				setLocationMessageType("danger");
				setTimeout(() => {
					setLocationMessage(null);
					setLocationMessageType(null);
				}, 5000);
			}
		} catch (error) {
			console.error("Konum isteği hatası:", error);
			setLocationMessage("Bağlantı hatası. Lütfen tekrar deneyin.");
			setLocationMessageType("danger");
			setTimeout(() => {
				setLocationMessage(null);
				setLocationMessageType(null);
			}, 5000);
		} finally {
			setRequestingLocation((prev) => ({ ...prev, [deviceId]: false }));
		}
	};

	// Vivistar kalp atışı ölçümü başlat
	const startVivistar = async (deviceId) => {
		try {
			const response = await fetch("https://app.vivasmartcare.com/api/v46-start-heartrate", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ deviceId }),
			});

			if (response.ok) {
				const data = await response.json();
				setHeartRateMessage(data.message || "Kalp atışı ölçümü başlatıldı");
				setHeartRateMessageType("success");
				// 3 saniye sonra mesajı kaldır
				setTimeout(() => {
					setHeartRateMessage(null);
					setHeartRateMessageType(null);
				}, 3000);
			} else {
				const errorData = await response.json();
				setHeartRateMessage(errorData.error || "Kalp atışı ölçümü başlatılamadı");
				setHeartRateMessageType("danger");
				// 5 saniye sonra mesajı kaldır
				setTimeout(() => {
					setHeartRateMessage(null);
					setHeartRateMessageType(null);
				}, 5000);
			}
		} catch (error) {
			console.error("Kalp atışı ölçümü hatası:", error);
			setHeartRateMessage("Bağlantı hatası. Lütfen tekrar deneyin.");
			setHeartRateMessageType("danger");
			// 5 saniye sonra mesajı kaldır
			setTimeout(() => {
				setHeartRateMessage(null);
				setHeartRateMessageType(null);
			}, 5000);
		}
	};

	// Vivistar cihazı bul (zil çaldır)
	const findVivistarsDevice = async (deviceId) => {
		try {
			await fetch("https://app.vivasmartcare.com/api/v46-find-device", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ deviceId }),
			});
			alert("Cihazda zil çalıyor!");
		} catch (error) {
			console.error("Cihaz bulma hatası:", error);
		}
	};

	// V46 alarmları kontrol et (popup için)
	const checkV46Alarms = async () => {
		try {
			const vivistarsItems =
				bed?.items?.filter((item) => item.brand === "Vivistar") || [];
			if (vivistarsItems.length === 0) return;

			const response = await fetch(
				`https://app.vivasmartcare.com/api/v46-recent-alarms?since=${lastV46AlarmCheck}`
			);
			if (response.ok) {
				const alarms = await response.json();
				// Bu yatak odasındaki cihazlara ait alarmları filtrele
				const deviceIds = vivistarsItems.map((item) => item.deviceID);
				const relevantAlarms = alarms.filter((a) =>
					deviceIds.includes(a.deviceId)
				);

				if (relevantAlarms.length > 0) {
					// En son alarmı popup olarak göster
					setV46AlarmPopup(relevantAlarms[0]);
					// Ses çal
					try {
						const audio = new Audio("/alarm.mp3");
						audio.play().catch(() => { });
					} catch (e) { }
				}
			}
			setLastV46AlarmCheck(new Date().toISOString());
		} catch (error) {
			console.error("V46 alarm kontrol hatası:", error);
		}
	};

	useEffect(() => {
		setSuBed(bed);
		getAlarmDetail();
		getUserDetails();
		console.log(battery);

		// Vivistar cihazları için veri çek
		bed?.items?.forEach((item) => {
			if (item.brand === "Vivistar") {
				fetchVivistar(item.deviceID);
			}
		});

		// Vivistar cihazları için periyodik güncelleme (30 saniye)
		const vivistarsItems =
			bed?.items?.filter((item) => item.brand === "Vivistar") || [];
		if (vivistarsItems.length > 0) {
			const dataInterval = setInterval(() => {
				vivistarsItems.forEach((item) => {
					fetchVivistar(item.deviceID);
				});
			}, 30000);

			// V46 alarm kontrolü (5 saniyede bir)
			const alarmInterval = setInterval(() => {
				checkV46Alarms();
			}, 5000);

			return () => {
				clearInterval(dataInterval);
				clearInterval(alarmInterval);
			};
		}
	}, [bed]);

	useEffect(() => {
		const updateMaps = () => {
			const newBedStatesMap = { ...bedStatesMap };

			bed.items.forEach((sbed) => {
				if (states.deviceId === sbed.deviceID) {
					newBedStatesMap[sbed.deviceID] = { ...states };
				}
			});

			setBedStatesMap(newBedStatesMap);
		};

		updateMaps();
	}, [states]);

	useEffect(() => {
		const updateMaps = () => {
			const newBedEventsMap = { ...bedEventsMap };

			bed.items.forEach((sbed) => {
				if (extractIdFromUrl(topic) === sbed.deviceID) {
					newBedEventsMap[sbed.deviceID] = { ...events };
				}
			});

			setBedEventsMap(newBedEventsMap);
		};

		updateMaps();
	}, [events]);

	const eventTypeMap = {
		calling: "Düşme Alarmı",
		inBed: "Yatağa Girme",
		"In Bed": "Yatağa Girme",
		outOfBed: "Yataktan Çıkma",
		"Out Of Bed": "Yataktan Çıkma",
		awayFromBed: "Yataktan Uzakta",
		bp: "Tansiyon Alarmı",
		rr: "Solunum Sayısı",
		hr: "Kalp Atış Hızı",
		bt: "Vücut Sıcaklığı Alarmı",
		callButton: "Aranma",
		fall: "Düşme Önleme Alarmı",
		falldetected: "Düşme Alarmı",
		"Low Heart Rate": "Düşük Kalp Atış Hızı",
		"High Heart Rate": "Yüksek Kalp Atış Hızı",
		"Low Respiration Rate": "Düşük Solunum Hızı",
		"High Respiration Rate": "Yüksek Solunum Hızı",
		head: "Epilepsi Alarmı",
		spo: "Oksijen Saturasyonu",
		tback: "Bası Yarası Hatırlatma",
		tleft: "Bası Yarası Hatırlatma",
		tright: "Bası Yarası Hatırlatma",
		"Posture Change": "Bası Yarası Hatırlatma",
		"Leave area": "Yataktan Çıkma",
		"Enter area": "Yatağa Girme",
		"Enter room": "Odaya Girme",
		"Leave room": "Odadan Çıkma",
		"Turn Resident": "Bası Yarası Hatırlatma",
		// Hobacare (Viva03D) Alarmları
		"Suspected fall": "Şüpheli Düşme",
		"Fall confirmation": "Düşme Onayı",
		"No event": "Olay Yok",
		// V46 Akıllı Saat Alarmları
		sos: "SOS Alarmı",
		falldown: "Düşme Alarmı",
		removewatch: "Saat Çıkarma Alarmı",
		lowbattery: "Düşük Batarya",
		heartrate_abnormal: "Anormal Kalp Atışı",
	};

	return (
		<>
			{/* Kalp Atış Ölçümü Geri Bildirimi */}
			{heartRateMessage && (
				<Alert
					variant={heartRateMessageType}
					onClose={() => {
						setHeartRateMessage(null);
						setHeartRateMessageType(null);
					}}
					dismissible
					style={{
						position: "fixed",
						top: "20px",
						right: "20px",
						zIndex: 9999,
						minWidth: "300px",
						boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
					}}
				>
					{heartRateMessage}
				</Alert>
			)}
			{/* Konum İsteği Geri Bildirimi */}
			{locationMessage && (
				<Alert
					variant={locationMessageType}
					onClose={() => {
						setLocationMessage(null);
						setLocationMessageType(null);
					}}
					dismissible
					style={{
						position: "fixed",
						top: heartRateMessage ? "80px" : "20px",
						right: "20px",
						zIndex: 9999,
						minWidth: "300px",
						boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
					}}
				>
					{locationMessage}
				</Alert>
			)}
			<div className="bed-card">
				{bed?.items[0].organization && (
					<Link
						className="organisation-name"
						to={`/nursing-home-detail/${slugify(bed?.items[0].organization)}`}
					>
						{bed?.items[0].organization}
					</Link>
				)}

				{bed?.suiteName && bed?.suiteName !== "" && (
					<div className="room-name suite">{bed?.suiteName}</div>
				)}

				{bed?.items?.map((bedItem) => (
					<div key={bedItem?.deviceID} className="same-card">
						<div className="room-name">
							{bedItem?.brand === "Viva02P" ? (
								<div className="vital-box">
									<Link to={`/viva02p/${bedItem?.deviceID}`}>
										<TfiHeartBroken size={16} color="red" /> {bedItem?.roomName}
									</Link>
									<Link to={`/viva02p/activities/${bedItem?.deviceID}`}>
										<FaRegCalendarCheck color="black" />
									</Link>
								</div>
							) : bedItem?.brand === "Viva03D" ? (
								<div className="hobacare-box">
									<Link to={`/viva02p/${bedItem?.deviceID}`}>
										<GiRadarSweep color="red" />
									</Link>
									{bedItem?.roomName}
								</div>
							) : bedItem?.brand === "Vivistar" ? (
								<div className="hobacare-box">
									<Link to={`/v46-vitals/${bedItem?.deviceID}`}>
										<BiSolidWatchAlt color="red" size={16} />
									</Link>
									{bedItem?.roomName}
								</div>
							) : (
								<>{bedItem?.roomName}</>
							)}
						</div>

						{bedItem?.brand !== "Viva02P" &&
							bedItem?.brand !== "Viva03D" &&
							bedItem?.brand !== "Vivistar" && (
								<Form.Group
									style={{ display: "flex", justifyContent: "flex-end" }}
								>
									<Form.Check
										type="switch"
										id="custom-switch"
										label="Bildirimler Kapalı"
										onChange={(e) =>
											handleToggleChange(bedItem?.deviceID, e.target.checked)
										}
									/>
								</Form.Group>
							)}

						{/* Hobacare verileri buraya gelecek */}
						{bedItem?.brand === "Viva03D" && hobaData[bedItem?.deviceID] && (
							<div>
								<p>
									{(() => {
										const deviceData = hobaData[bedItem?.deviceID];
										const base64 = deviceData?.payload?.heartbreath;
										if (!base64) return <p>-- --</p>;

										let heartData;
										try {
											const binaryString = atob(base64);
											const bytes = Uint8Array.from(binaryString, (c) =>
												c.charCodeAt(0)
											);

											const statusByte = bytes[13] || 0;
											const sleepBits = (statusByte >> 6) & 0b11;

											// Posture (yatakta olup olmama kontrolü)
											const postureValue = statusByte;
											const inBedStates = [6, 9, 10, 11];
											const isInBed = inBedStates.includes(postureValue);

											const sleepStateMap = {
												0b00: "Tanımsız",
												0b01: "Hafif uyku",
												0b10: "Derin uyku",
												0b11: "Uyanık",
											};

											heartData = {
												identifier: bytes[0],
												breathing: bytes[1],
												heartRate: bytes[2],
												sleepState: sleepStateMap[sleepBits] || "Bilinmiyor",
												inBed: isInBed,
											};
										} catch (e) {
											return "Geçersiz Base64";
										}

										return (
											<div
												style={{
													display: "flex",
													flexDirection: "column",
													gap: "12px",
												}}
											>
												<div className="hobadata">
													<p>Solunum</p>
													<p>{heartData.breathing} rpm</p>
												</div>
												<div className="hobadata">
													<p>Nabız</p>
													<p>{heartData.heartRate} bpm</p>
												</div>
												{/* Konum ikonu - Tıklandığında token alıp linke git */}
												<div
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														cursor: "pointer",
													}}
													onClick={async () => {
														const token = await fetchHobaToken();
														if (token) {
															window.open(
																`https://qinglanst.com/single/rommDetails?uid=${bedItem?.deviceID}&token=${token}&readOnly=true&isApp=true&lang=en_US`,
																"_blank"
															);
														} else {
															console.error("Token alınamadı!");
														}
													}}
												>
													<MdLocationPin size={24} />
												</div>
											</div>
										);
									})()}
								</p>

								{/* <p>position {hobaData?.payload?.position}</p>
                  <p>statics {hobaData?.payload?.hbstatics}</p> */}
							</div>
						)}

						{/* Vivistar Akıllı Saat */}
						{bedItem?.brand === "Vivistar" && (
							<div
								style={{
									background:
										"linear-gradient(135deg, #00a3e0 0%, #0057a6 100%)",
									borderRadius: "12px",
									padding: "10px",
									color: "white",
									width: "100%",
									boxSizing: "border-box",
								}}
							>
								{/* Üst Bar */}
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "10px",
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "4px",
										}}
									>
										<div
											style={{
												width: "8px",
												height: "8px",
												borderRadius: "50%",
												backgroundColor: vivistar[bedItem.deviceID]?.isConnected
													? "#4ade80"
													: "#9ca3af",
											}}
										/>
										<FaBatteryThreeQuarters size={12} />
										<span style={{ fontSize: "11px" }}>
											{vivistar[bedItem.deviceID]?.battery || "--"}%
										</span>
									</div>
									<OverlayTrigger
										placement="top"
										overlay={<Tooltip>Cihazı Bul</Tooltip>}
									>
										<span
											style={{ cursor: "pointer", fontSize: "14px" }}
											onClick={() => findVivistarsDevice(bedItem.deviceID)}
										>
											🔔
										</span>
									</OverlayTrigger>
								</div>

								{/* Vital List */}
								<div
									style={{
										display: "flex",
										flexDirection: "column",
										gap: "6px",
										marginBottom: "10px",
									}}
								>
									{/* Kalp */}
									<div
										style={{
											background: "rgba(255,255,255,0.15)",
											borderRadius: "8px",
											padding: "8px",
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "6px",
											}}
										>
											<FaHeartbeat size={14} />
											<span style={{ fontSize: "11px" }}>Kalp</span>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "6px",
											}}
										>
											<span style={{ fontSize: "16px", fontWeight: "700" }}>
												{vivistar[bedItem.deviceID]?.vitals?.heartRate || "--"}{" "}
												<span style={{ fontSize: "10px", fontWeight: "400" }}>
													bpm
												</span>
											</span>
											<span
												style={{ cursor: "pointer", fontSize: "12px" }}
												onClick={() => startVivistar(bedItem.deviceID)}
											>
												📏
											</span>
										</div>
									</div>

									{/* Tansiyon */}
									<div
										style={{
											background: "rgba(255,255,255,0.15)",
											borderRadius: "8px",
											padding: "8px",
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "6px",
											}}
										>
											<ImHeart size={14} />
											<span style={{ fontSize: "11px" }}>Tansiyon</span>
										</div>
										<span style={{ fontSize: "16px", fontWeight: "700" }}>
											{vivistar[bedItem.deviceID]?.vitals?.bloodPressureSystolic
												? `${vivistar[bedItem.deviceID].vitals
													.bloodPressureSystolic
												}/${vivistar[bedItem.deviceID].vitals
													.bloodPressureDiastolic
												}`
												: "--"}
										</span>
									</div>

									{/* SpO2 */}
									<div
										style={{
											background: "rgba(255,255,255,0.15)",
											borderRadius: "8px",
											padding: "8px",
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "6px",
											}}
										>
											<FaLungs size={14} />
											<span style={{ fontSize: "11px" }}>SpO2</span>
										</div>
										<span style={{ fontSize: "16px", fontWeight: "700" }}>
											{vivistar[bedItem.deviceID]?.vitals?.bloodOxygen || "--"}
											<span style={{ fontSize: "10px", fontWeight: "400" }}>
												%
											</span>
										</span>
									</div>

									{/* Sıcaklık */}
									<div
										style={{
											background: "rgba(255,255,255,0.15)",
											borderRadius: "8px",
											padding: "8px",
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: "6px",
											}}
										>
											<span style={{ fontSize: "14px" }}>🌡️</span>
											<span style={{ fontSize: "11px" }}>Sıcaklık</span>
											<button
												title="Sıcaklık Ölç"
												onClick={async (e) => {
													e.preventDefault();
													e.stopPropagation();
													const btn = e.currentTarget;
													btn.disabled = true;
													btn.style.opacity = "0.5";
													try {
														const response = await fetch(
															"https://app.vivasmartcare.com/api/v46-start-temperature",
															{
																method: "POST",
																body: JSON.stringify({ deviceId: bedItem.deviceID }),
																headers: { "Content-Type": "application/json" },
															}
														);
														btn.textContent = response.ok ? "✓" : "✗";
													} catch (error) {
														console.error("Sıcaklık ölçüm hatası:", error);
														btn.textContent = "✗";
													}
													setTimeout(() => {
														btn.disabled = false;
														btn.textContent = "⟳";
														btn.style.opacity = "1";
													}, 2000);
												}}
												style={{
													background: "none",
													border: "none",
													color: "white",
													fontSize: "16px",
													cursor: "pointer",
													padding: "0 2px",
													opacity: "0.7",
													lineHeight: "1",
												}}
											>
												⟳
											</button>
										</div>
										<span style={{ fontSize: "16px", fontWeight: "700" }}>
											{vivistar[bedItem.deviceID]?.vitals?.bodyTemperature ||
												"--"}
											<span style={{ fontSize: "10px", fontWeight: "400" }}>
												°C
											</span>
										</span>
									</div>
								</div>

								{/* Alt Bar */}
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										background: "rgba(255,255,255,0.1)",
										borderRadius: "8px",
										padding: "6px 8px",
										flexWrap: "wrap",
										gap: "8px",
									}}
								>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "4px",
										}}
									>
										<span style={{ fontSize: "12px" }}>👟</span>
										<span style={{ fontSize: "11px", fontWeight: "600" }}>
											{vivistar[bedItem.deviceID]?.steps?.toLocaleString() ||
												"0"}
										</span>
									</div>

									{/* Konum Butonu */}
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "3px",
											cursor: requestingLocation[bedItem.deviceID] ? "wait" : "pointer",
											background: "rgba(255,255,255,0.2)",
											padding: "3px 6px",
											borderRadius: "6px",
											flexShrink: 0,
											opacity: requestingLocation[bedItem.deviceID] ? 0.6 : 1,
										}}
										onClick={async () => {
											if (requestingLocation[bedItem.deviceID]) return;
											const loc = vivistar[bedItem.deviceID]?.location;
											if (loc && loc.latitude && loc.longitude) {
												window.open(
													`https://www.google.com/maps?q=${loc.latitude},${loc.longitude}`,
													"_blank"
												);
											} else {
												await requestVivistarlocation(bedItem.deviceID);
											}
										}}
									>
										{requestingLocation[bedItem.deviceID] ? (
											<>
												<span
													className="spinner-border spinner-border-sm"
													role="status"
													aria-hidden="true"
													style={{ width: "8px", height: "8px" }}
												></span>
												<span style={{ fontSize: "9px", whiteSpace: "nowrap" }}>İsteniyor...</span>
											</>
										) : (
											<>
												<FaLocationDot size={9} />
												<span style={{ fontSize: "9px", whiteSpace: "nowrap" }}>
													{vivistar[bedItem.deviceID]?.location?.latitude
														? "Konum"
														: "Konum Yok"}
												</span>
											</>
										)}
									</div>
									{vivistar[bedItem.deviceID]?.lastLocationUpdate && (
										<span style={{ fontSize: "7px", opacity: 0.5 }}>
											{dateFormat(vivistar[bedItem.deviceID].lastLocationUpdate)}
										</span>
									)}
								</div>

								{/* Son Güncelleme */}
								{vivistar[bedItem.deviceID]?.lastSeen && (
									<div
										style={{
											textAlign: "center",
											fontSize: "8px",
											opacity: 0.6,
											marginTop: "6px",
										}}
									>
										{dateFormat(vivistar[bedItem.deviceID].lastSeen)}
									</div>
								)}
							</div>
						)}

						{["Viva02P"].includes(bedItem?.brand) && (
							<div className="vitals-wrapper">
								<div className="vitals-container">
									<div className="title">Nabız</div>
									<div className="box">
										<div className="left-box">
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);

													const highestHRMessage = matchingMessages.reduce(
														(max, current) =>
															current.HR > (max.HR || 0) ? current : max,
														{}
													);
													return highestHRMessage?.HR ? (
														highestHRMessage.HR
													) : (
														<p>--</p>
													);
												})()}
											</p>
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);
													const lowestHRMessage = matchingMessages.reduce(
														(min, current) =>
															current.HR < (min.HR || Infinity) ? current : min,
														{}
													);
													return lowestHRMessage?.HR ? (
														lowestHRMessage.HR
													) : (
														<p>--</p>
													);
												})()}
											</p>
										</div>
										<div className="right-box">
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);
													const lastMessage =
														matchingMessages[matchingMessages.length - 1];
													return lastMessage?.HR ? lastMessage.HR : <p>--</p>;
												})()}
											</p>
										</div>
									</div>
									<p className="bpm">bpm</p>
								</div>
								<div className="vitals-container">
									<div className="title">Solunum</div>
									<div className="box">
										<div className="left-box">
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);

													const highestRRMessage = matchingMessages.reduce(
														(max, current) =>
															current.RR > (max.RR || 0) ? current : max,
														{}
													);
													return highestRRMessage?.RR ? (
														highestRRMessage.RR
													) : (
														<p>--</p>
													);
												})()}
											</p>
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);
													const lowestRRMessage = matchingMessages.reduce(
														(min, current) =>
															current.RR < (min.RR || Infinity) ? current : min,
														{}
													);
													return lowestRRMessage?.RR ? (
														lowestRRMessage.RR
													) : (
														<p>--</p>
													);
												})()}
											</p>
										</div>
										<div className="right-box">
											<p>
												{(() => {
													const matchingMessages = messages.filter(
														(message) => message.deviceId === bedItem.deviceID
													);
													const lastMessage =
														matchingMessages[matchingMessages.length - 1];
													return lastMessage?.RR ? lastMessage.RR : <p>--</p>;
												})()}
											</p>
										</div>
									</div>
									<p className="bpm">rpm</p>
								</div>
							</div>
						)}

						{countAlarmsByDeviceId(alarms, bedItem.deviceID) > 3 ? (
							<Accordion>
								<Accordion.Item eventKey="0">
									<Accordion.Header>
										Alarm Sayısı{" "}
										<span className="alarm-count">
											{countAlarmsByDeviceId(alarms, bedItem.deviceID)}
										</span>
									</Accordion.Header>
									<Accordion.Body>
										{alarms
											?.filter((alarmArray) => alarmArray.length > 0)
											.flat()
											.filter((alarm) => alarm.deviceId === bedItem.deviceID)
											.sort(
												(a, b) => new Date(b.createdAt) - new Date(a.createdAt)
											)
											.map((alarm, index) => {
												const alarmLabel =
													eventTypeMap[alarm?.eventType] || "Alarm";
												const alarmClass =
													alarm?.eventType === "calling" ? "red" : "yellow";

												return (
													<div className="alarms" key={index}>
														<div
															className={`alarm-type ${alarmClass}`}
															onClick={() => {
																handleShow();
																setAlarm(alarm);
															}}
														>
															{alarmLabel}
														</div>
													</div>
												);
											})}
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						) : (
							alarms
								?.filter((alarmArray) => alarmArray.length > 0)
								.map((alarmArray, index) =>
									alarmArray
										.filter((alarm) => alarm.deviceId === bedItem.deviceID)
										.map((alarm, subIndex) => (
											<div className="alarms">
												<div
													key={`${index}-${subIndex}`}
													className={`alarm-type ${alarm?.eventType !== "calling" ? "yellow" : "red"
														}`}
													onClick={() => {
														handleShow();
														setAlarm(alarm);
													}}
												>
													{eventTypeMap[alarm?.eventType]}
												</div>
											</div>
										))
								)
						)}
						<div
							className="device-container"
							onClick={() => {
								setLastAlarmId(bedItem?.deviceID);
								setLastAlarmsShow(true);
							}}
						>
							<div className="device-wrapper">
								{logs &&
									logs.length > 0 &&
									(() => {
										const filteredLogs = logs.filter(
											(log) =>
												log.deviceId === bedItem?.deviceID &&
												log.dataType === "event"
										);
										const lastFilteredLog =
											filteredLogs[filteredLogs.length - 1];

										const isPresenceDetected =
											lastFilteredLog &&
											lastFilteredLog.vayyarData?.payload &&
											lastFilteredLog.vayyarData.payload.presenceDetected ===
											true;

										return isPresenceDetected ? (
											<>
												<span
													className={`material-symbols-rounded ${isPresenceDetected && "in-bed"
														}`}
												>
													{symbols[bedItem?.roomType]}
												</span>
											</>
										) : (
											<span className="material-symbols-rounded">
												{symbols[bedItem?.roomType]}
											</span>
										);
									})()}
								{bedEventsMap[bedItem?.deviceID]?.payload?.presenceDetected ===
									false && (
										<span className={`material-symbols-rounded`}>
											{symbols[bedItem?.roomType]}
										</span>
									)}
								{bedEventsMap[bedItem?.deviceID]?.payload?.presenceDetected ===
									true && (
										<span className={`material-symbols-rounded in-bed`}>
											{symbols[bedItem?.roomType]}
										</span>
									)}
								{bedEventsMap[bedItem?.deviceID]?.payload
									?.presenceRegionMap?.[0] === 1 &&
									bedItem?.roomType === "Yatak Odası" && (
										<>
											<FaBed fill="orange" />
										</>
									)}
								{logs &&
									logs.length > 0 &&
									(() => {
										const filteredLogs = logs.filter(
											(log) =>
												log.deviceId === bedItem?.deviceID &&
												log.dataType === "event"
										);

										const lastFilteredLog =
											filteredLogs[filteredLogs.length - 1];
										const secondLastFilteredLog =
											filteredLogs[filteredLogs.length - 2];

										const isOutBed =
											lastFilteredLog &&
											secondLastFilteredLog &&
											lastFilteredLog.vayyarData?.payload &&
											lastFilteredLog.vayyarData?.payload.presenceRegionMap &&
											secondLastFilteredLog.vayyarData?.payload &&
											secondLastFilteredLog.vayyarData?.payload
												.presenceRegionMap &&
											lastFilteredLog.vayyarData?.payload
												.presenceRegionMap[0] === 0 &&
											secondLastFilteredLog.vayyarData?.payload
												.presenceRegionMap[0] === 1;

										return (
											isOutBed &&
											bedItem?.brand !== "Minifinder" &&
											bedItem?.roomType === "Yatak Odası" && (
												<>
													<Modal show={outBedModalShow} onHide={outBedClose}>
														<Modal.Header closeButton>
															<Modal.Title>
																{bedItem.suiteName} adlı süit için yataktan
																çıkma bildirimi
															</Modal.Title>
														</Modal.Header>
														<Modal.Body></Modal.Body>
														<Modal.Footer>
															<Button variant="secondary" onClick={outBedClose}>
																Kapat
															</Button>
														</Modal.Footer>
													</Modal>
												</>
											)
										);
									})()}
								{/* Wifi Status */}
								{bedStatesMap[bedItem?.deviceID]?.wifiState.rssi <= -80 && (
									<div className="rssi">!</div>
								)}
								{/* Vayyar Online Offline */}
								{(bedItem.brand === "Viva02P" || bedItem.brand === "Vayyar") &&
									(messages.some(
										(message) => message.deviceId === bedItem.deviceID
									) ||
										bedStatesMap[bedItem.deviceID]?.status === "test" ||
										bedStatesMap[bedItem.deviceID]?.status === "learning" ||
										bedStatesMap[bedItem.deviceID]?.status === "monitoring" ? (
										<IoIosWifi fill="green" />
									) : (
										<MdSignalWifiConnectedNoInternet2 fill="red" />
									))}

								{bedItem.brand === "Viva03D" &&
									(() => {
										const deviceData = hobaData[bedItem.deviceID];
										const isOnline = !!deviceData;
										let inBed = false;
										let standing = false;

										const base64 = deviceData?.payload?.heartbreath;
										let postureText = "";
										if (base64) {
											try {
												const binaryString = atob(base64);
												const bytes = Uint8Array.from(binaryString, (c) =>
													c.charCodeAt(0)
												);
												const breathingValue = bytes[1]; // Solunum değeri
												const statusByte = bytes[13] || 0;
												const postureValue = statusByte;

												// Posture açıklamaları
												const postureMap = {
													1: "Yürüyor",
													2: "Düşme Şüphesi",
													3: "Çömelme",
													4: "Ayakta",
													5: "Düşme Onayı",
													7: "Yerde Oturma Şüphesi",
													8: "Yerde Oturuyor",
												};
												postureText = postureMap[postureValue] || "Odada";

												// Eğer solunum verisi varsa yatakta
												if (breathingValue > 0) {
													inBed = true;
												} else {
													// Odada olan ama yatakta olmayan durumlar: 1, 2, 3, 4, 5, 7, 8
													const inRoomNotInBedStates = [1, 2, 3, 4, 5, 7, 8];
													if (inRoomNotInBedStates.includes(postureValue)) {
														standing = true;
													}
												}
											} catch (e) {
												console.error(
													"Heartbreath/solunum verisi çözülemedi:",
													e
												);
											}
										}

										return (
											<div
												style={{
													display: "flex",
													alignItems: "center",
													gap: "8px",
												}}
											>
												{/* Online durumu */}
												{isOnline ? (
													<IoIosWifi fill="green" />
												) : (
													<MdSignalWifiConnectedNoInternet2 fill="red" />
												)}

												{/* Hasta durumu */}
												{base64 && (
													<>
														{inBed && <FaBed color="orange" />}
														{standing && (
															<OverlayTrigger
																placement="top"
																overlay={
																	<Tooltip
																		id={`standing-tooltip-${bedItem.deviceID}`}
																	>
																		{postureText}
																	</Tooltip>
																}
															>
																<span>
																	<IoManSharp color="orange" size={20} />
																</span>
															</OverlayTrigger>
														)}
													</>
												)}
											</div>
										);
									})()}

								{bedItem.brand === "Viva02P" && (
									<p>
										{(() => {
											const matchingBattery = battery.filter(
												(battery) => battery.deviceId === bedItem.deviceID
											);
											const lastBattery =
												matchingBattery[matchingBattery.length - 1];
											return lastBattery?.value ? (
												JSON.parse(lastBattery.value).Level > 1 && <></>
											) : (
												<FaPlugCircleXmark color="red" />
											);
										})()}
									</p>
								)}
								{bedItem.brand === "Viva02P" && (
									<p>
										{(() => {
											const matchingMessages = messages.filter(
												(message) => message.deviceId === bedItem.deviceID
											);

											const highestHRMessage = matchingMessages.reduce(
												(max, current) =>
													current.HR > (max.HR || 0) ? current : max,
												{}
											);
											return highestHRMessage?.HR ? (
												<FaBed fill="orange" />
											) : (
												<PiBedFill />
											);
										})()}
									</p>
								)}
								{bedItem.brand === "Vivistar" && vivistar[bedItem.deviceID] && (
									<div className="vivi-box">
										{vivistar[bedItem.deviceID]?.isConnected ? (
											<IoIosWifi color="green" />
										) : (
											<MdSignalWifiConnectedNoInternet2 color="gray" />
										)}
										<FaBatteryThreeQuarters
											color={
												vivistar[bedItem.deviceID]?.battery > 20
													? "green"
													: "red"
											}
										/>
										<p>
											{vivistar[bedItem.deviceID]?.battery
												? `%${vivistar[bedItem.deviceID].battery}`
												: "--"}
										</p>
									</div>
								)}
								{/* Last Update */}
								{logs &&
									logs.length > 0 &&
									(() => {
										const filteredLogs = logs.filter(
											(log) =>
												log.deviceId === bedItem?.deviceID &&
												log.dataType === "event"
										);
										const lastFilteredLog =
											filteredLogs[filteredLogs.length - 1];

										const isPresenceDetected =
											lastFilteredLog &&
											lastFilteredLog.vayyarData?.payload &&
											lastFilteredLog.vayyarData.payload.presenceDetected ===
											true;

										return (
											isPresenceDetected && (
												<OverlayTrigger
													key={"top"}
													placement={"top"}
													overlay={
														<Tooltip id={`tooltip-top`} className="last-update">
															<span>Son Güncellenme Tarihi:</span>
															<span>
																{dateFormat(lastFilteredLog.createdAt)}
															</span>
														</Tooltip>
													}
												>
													<Button style={{ all: "unset" }}>
														<FcInfo />
													</Button>
												</OverlayTrigger>
											)
										);
									})()}
							</div>
						</div>
					</div>
				))}

				{lastAlarmsShow === true && (
					<LastFiveAlarm
						id={lastAlarmId}
						closeLastAlarmsModal={closeLastAlarmsModal}
						lat={minidata?.lat || null}
						long={minidata?.long || null}
					/>
				)}

				{bed.vital === true && (
					<div className="vital-container">
						<Link to="/">
							<BsFillHeartPulseFill color="#00A3E0" size={32} />
						</Link>
					</div>
				)}
			</div>

			{show === true && (
				<AlarmModal
					alarm={alarm}
					userDetail={userDetail}
					bed={bed}
					closeModal={closeModal}
				/>
			)}

			{/* V46 Alarm Popup */}
			{v46AlarmPopup && (
				<Modal show={true} onHide={closeV46AlarmPopup} centered>
					<Modal.Header
						style={{
							background:
								v46AlarmPopup.eventType === "sos"
									? "#dc2626"
									: v46AlarmPopup.eventType === "falldown"
										? "#ea580c"
										: "#f59e0b",
							color: "white",
						}}
					>
						<Modal.Title
							style={{ display: "flex", alignItems: "center", gap: "10px" }}
						>
							<span style={{ fontSize: "24px" }}>
								{v46AlarmPopup.eventType === "sos"
									? "🆘"
									: v46AlarmPopup.eventType === "falldown"
										? "⚠️"
										: "⌚"}
							</span>
							{v46AlarmPopup.eventType === "sos"
								? "SOS ALARMI"
								: v46AlarmPopup.eventType === "falldown"
									? "DÜŞME ALARMI"
									: v46AlarmPopup.eventType === "removewatch"
										? "SAAT ÇIKARILDI"
										: "ALARM"}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body style={{ padding: "20px" }}>
						<div
							style={{ display: "flex", flexDirection: "column", gap: "12px" }}
						>
							{/* Kurum Bilgisi */}
							{bed?.organization && (
								<div
									style={{ display: "flex", alignItems: "center", gap: "8px" }}
								>
									<span style={{ fontWeight: "600" }}>Kurum:</span>
									<span>{bed.organization}</span>
								</div>
							)}
							{/* Suite Name */}
							{bed?.suiteName && (
								<div
									style={{ display: "flex", alignItems: "center", gap: "8px" }}
								>
									<span style={{ fontWeight: "600" }}>Süit:</span>
									<span>{bed.suiteName}</span>
								</div>
							)}
							{/* Oda İsmi */}
							{bed?.roomName && (
								<div
									style={{ display: "flex", alignItems: "center", gap: "8px" }}
								>
									<span style={{ fontWeight: "600" }}>Oda:</span>
									<span>{bed.roomName}</span>
								</div>
							)}
							<div
								style={{ display: "flex", alignItems: "center", gap: "8px" }}
							>
								<span style={{ fontWeight: "600" }}>Cihaz:</span>
								<span>{v46AlarmPopup.deviceId}</span>
							</div>
							<div
								style={{ display: "flex", alignItems: "center", gap: "8px" }}
							>
								<span style={{ fontWeight: "600" }}>Zaman:</span>
								<span>{dateFormat(v46AlarmPopup.createdAt)}</span>
							</div>
							{v46AlarmPopup.description && (
								<div
									style={{
										background: "#f3f4f6",
										padding: "10px",
										borderRadius: "8px",
										marginTop: "8px",
									}}
								>
									{v46AlarmPopup.description}
								</div>
							)}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={closeV46AlarmPopup}>
							Kapat
						</Button>
					</Modal.Footer>
				</Modal>
			)}
		</>
	);
};

export default SameSuitCard;
